<template>
  <v-row justify="center">
    <v-dialog
      v-model="show_dialog"
      persistent
      max-width="90%"
    >
      <v-card>
        <v-card-title>
          <div class="table-title">{{ title }}</div>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row class="mt-2">
              <v-col cols="12">
                <p style="text-align: center">Valor actual en la máquina: {{ original_value }}</p>
              </v-col>
              <v-col
                class="pt-0"
                cols="12"
              >
                <p style="text-align: center"><v-text-field v-model="value"></v-text-field></p>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                :cols="extended_version ? '3' : '4'"
                class="pa-1"
              >
                <v-btn
                  block
                  @click="add('7')"
                  >7</v-btn
                >
              </v-col>
              <v-col
                :cols="extended_version ? '3' : '4'"
                class="pa-1"
              >
                <v-btn
                  block
                  @click="add('8')"
                  >8</v-btn
                >
              </v-col>
              <v-col
                :cols="extended_version ? '3' : '4'"
                class="pa-1"
              >
                <v-btn
                  block
                  @click="add('9')"
                  >9</v-btn
                >
              </v-col>
              <v-col
                v-if="extended_version"
                :cols="3"
                class="pa-1"
              >
                <v-btn
                  block
                  @click="add('sign')"
                  >+/-</v-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col
                :cols="extended_version ? '3' : '4'"
                class="pa-1"
              >
                <v-btn
                  block
                  @click="add('4')"
                  >4</v-btn
                >
              </v-col>
              <v-col
                :cols="extended_version ? '3' : '4'"
                class="pa-1"
              >
                <v-btn
                  block
                  @click="add('5')"
                  >5</v-btn
                >
              </v-col>
              <v-col
                :cols="extended_version ? '3' : '4'"
                class="pa-1"
              >
                <v-btn
                  block
                  @click="add('6')"
                  >6</v-btn
                >
              </v-col>
              <v-col
                v-if="extended_version"
                :cols="3"
                class="pa-1"
              >
                <v-btn
                  block
                  @click="add('back')"
                  >&lt;=</v-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col
                :cols="extended_version ? '3' : '4'"
                class="pa-1"
              >
                <v-btn
                  block
                  @click="add('1')"
                  >1</v-btn
                >
              </v-col>
              <v-col
                :cols="extended_version ? '3' : '4'"
                class="pa-1"
              >
                <v-btn
                  block
                  @click="add('2')"
                  >2</v-btn
                >
              </v-col>
              <v-col
                :cols="extended_version ? '3' : '4'"
                class="pa-1"
              >
                <v-btn
                  block
                  @click="add('3')"
                  >3</v-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col
                :cols="extended_version ? '3' : '8'"
                class="pa-1"
              >
                <v-btn
                  block
                  @click="add('0')"
                  >0</v-btn
                >
              </v-col>
              <v-col
                v-if="extended_version"
                :cols="3"
                class="pa-1"
              >
                <v-btn
                  block
                  @click="add('.')"
                  >.</v-btn
                >
              </v-col>
              <v-col
                :cols="extended_version ? '3' : '4'"
                class="pa-1"
              >
                <v-btn
                  block
                  @click="add('clear')"
                  >BORRAR</v-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col
                :cols="extended_version ? '6' : '8'"
                class="pa-1"
              >
                <v-btn
                  block
                  @click="add('cancel')"
                  >CANCELAR</v-btn
                >
              </v-col>
              <v-col
                :cols="extended_version ? '6' : '4'"
                class="pa-1"
              >
                <v-btn
                  block
                  @click="add('enter')"
                >
                  ENVIAR
                </v-btn>
              </v-col>
            </v-row>

            <v-row class="pt-5">
              <v-col cols="6">
                <p style="text-align: center">Min: {{ min_value }}</p>
              </v-col>
              <v-col cols="6">
                <p style="text-align: center">Max: {{ max_value }}</p>
              </v-col>
            </v-row>
            <v-row
              class="mt-2"
              v-if="error_text"
            >
              <v-col cols="12">
                <p style="text-align: center; color: red">
                  {{ error_text }}
                </p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    show_dialog: true,
    value: null,
    error_text: null,
  }),

  props: {
    title: String,
    min_value: [Number, String],
    max_value: [Number, String],
    original_value: [Number, String],
    extended_version: Boolean,
  },

  methods: {
    add(v) {
      if (!isNaN(v)) {
        this.value == 0 ? (this.value = v) : (this.value += v);
      } else {
        switch (v) {
          case "sign":
            this.value *= -1;
            this.value = this.value.toString();
            break;

          case "back":
            this.value = this.value.slice(0, -1);
            if (this.value.charAt(this.value.length - 1) == ".") this.value = this.value.slice(0, -1);
            break;

          case "clear":
            this.value = "";
            break;

          case ".":
            if (!this.value.includes(".")) this.value += ".";
            break;

          case "cancel":
            this.$emit("cancel");
            break;

          case "enter":
            if (!isNaN(this.value)) {
              if (
                parseFloat(this.value) <= parseFloat(this.max_value) &&
                parseFloat(this.value) >= parseFloat(this.min_value)
              ) {
                this.$emit("submit", this.value);
              } else {
                this.error_text = "EL VALOR INTRODUCIDO NO SE ENCUENTRA DENTRO DEL RANGO";
              }
            } else {
              this.error_text = "EL VALOR INTRODUCIDO NO ES UN VALOR NUMÉRICO";
            }
            break;

          default:
            break;
        }
      }
    },
  },

  mounted() {
    this.value = this.original_value;
  },
};
</script>
